<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <v-row>
          <v-col
            :md="isNotSicialRoute ? 6 : ''"
            class="mt-2 pb-0"
            cols="12"
          >
            <div class="rowinfo">
              <v-text-field
                v-model="data.organizationName"
                :append-icon="isGiftRoute?'mdi-account-heart-outline':isTextRoute? 'mdi-text':'mdi-account-outline'"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="50"
                class="contentinfo"
                dense
                :hint="!isGiftRoute?'لطفا عنوان خود را وارد کنید.':'لطفا عنوان پیام خود را وارد کنید.' "
                :label="!isGiftRoute?'عنوان':'عنوان پیام' "
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-organizationName`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="عنوان"
              />
            </div>
          </v-col>
          <v-col
            v-if="isNotSicialRoute"
            :md="isNotSicialRoute ? 6 : ''"
            class="mt-2 pb-0"
            cols="12"
          >
            <div class="rowinfo">
              <v-text-field
                v-model="data.subtitle"
                :append-icon="!isGiftRoute?'mdi-account-outline':'mdi-account-heart-outline'"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="100"
                class="contentinfo"
                dense
                :hint="isTextRoute? 'زیر عنوانی برای متن خود وارد کنید':!isGiftRoute?'لطفا  زیرنام مجموعه خود را وارد کنید.':'لطفا یک جمله کوتاه برای شروع وارد کنید'"
                :label="isTextRoute? 'زیر عنوان متن':!isGiftRoute?'زیرنام مجموعه':'یک جمله کوتاه برای شروع' "
                maxLength="100"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-subtitle`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="isTextRoute? 'زیر عنوان متن':!isGiftRoute?'زیرنام مجموعه':'یک جمله کوتاه برای شروع' "
              />
            </div>
          </v-col>
          <v-col class="mt-2 py-0" cols="12">
            <div class="rowinfo">
            <v-text-field
            v-if="isGiftRoute"
                v-model="data.website"
                append-icon="mdi-heart"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                dense
                hint="مثال: تقدیم به..."
                label="امضای خاطره"
                outlined
              />
              <v-text-field
              v-else-if="!isTextRoute"
                v-model="data.website"
                :rules="urlRules"
                append-icon="mdi-earth"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                counter="50"
                dense
                hint="لطفا آدرس وبسایت  خود را وارد کنید."
                label="آدرس وبسایت"
                maxLength="50"
                outlined
              />
              <help-info
                v-else-if="!isTextRoute"
                :element-name="`${serviceName}-${componentName}-data-website`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="آدرس وبسایت"
              />
            </div>
          </v-col>
          <v-col
            v-if="
              ![
                'qr.name.editPhoto',
                'qr.name.id.editPhoto',
                'qr.photo',
                'qr.create.photoGalleryModel',
                'qr.create.photoGalleryedit',
                'qr.create.pdfGalleryModel',
                'qr.create.pdfGalleryedit',
                'qr.video',
                'qr.name.editVideo',
                'qr.name.id.editVideo',
                'qr.pdf',
                'qr.name.id.editPdf',
                'qr.name.editPdf',
              ].includes($route.name)
            "
            class="mt-2 py-0"
            cols="12"
          >
            <div class="rowinfo">
              <suggest-text
                v-model="data.aboutUs"
                :label="isTextRoute?'متن من':!isGiftRoute?'درباره ما':'متن خاطره'"
                rows="8"
                class="contentinfo"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-aboutUs`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="isTextRoute?'متن من':!isGiftRoute?'درباره ما':'متن خاطره'"
              />
            </div>
          </v-col>

          <v-col
            v-if="
              [
                'qr.name.editPhoto',
                'qr.name.id.editPhoto',
                'qr.create.photoGalleryModel',
                'qr.create.photoGalleryedit',
                'qr.photo',
                'qr.video',
                'qr.name.editVideo',
                'qr.name.id.editVideo',
                'qr.pdf',
                'qr.name.id.editPdf',
                'qr.name.editPdf',
                'qr.create.pdfGalleryedit',
                'qr.create.pdfGalleryModel',
                'qr.Qrtext',
                'qr.name.editText',
                'qr.name.id.editText'
              ].includes($route.name)
            "
            class="mt-2 py-0"
            cols="12"
          >
            <extra-fileds v-model="data.extraFields" block />
          </v-col>
          <v-col
            v-if="!isNotSicialRoute"
            class="mt-2 py-0"
            cols="12"
          >
            <div class="rowinfo">
              <v-text-field
                v-model="data.buttonName"
                append-icon="mdi-account-outline"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                counter="100"
                dense
                hint="لطفا  نام دکمه خود را وارد کنید."
                label="نام دکمه "
                maxLength="100"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-buttonName`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="نام دکمه "
              />
            </div>
          </v-col>

          <v-col cols="12" class="mt-4 pt-0"             
          v-if="isGiftRoute"
>
            <v-divider class="mb-4"></v-divider>
            <h3 class="mb-3 font-weight-bold text-subtitle-1">تاریخ‌های مهم خود را اضافه نمایید:</h3>
            
            <div
              v-for="(memory, index) in data.memories"
              :key="index"
              class="d-flex align-center mb-5 pa-4"
              style="border: 1px solid #e0e0e0; border-radius: 12px; background-color: #fcfcfc;"
            >
              <!-- بخش فیلدهای ورودی -->
              <div class="d-flex flex-column flex-grow-1">
                
                <!-- ردیف اول: عنوان (تمام‌عرض) -->
                <suggest-text
                  v-model="memory.title"
                  class="mb-4"
                  label="عنوان"
                  rows="1"
                />

                <!-- ردیف دوم: انتخاب آیکون و تاریخ (کنار هم) -->
                <div class="d-flex">
                  <icon-picker
                    v-model="memory.icon"
                    class="ml-3 flex-grow-1"
                  />
                  
                  <custom-date-picker
                    v-model="memory.date"
                    append-icon="mdi-calendar-heart"
                    class="rounded-lg flex-grow-1"
                    dense
                    hide-details
                    format="date"
                    :input-class="'created-input-' + index"
                    label="انتخاب تاریخ"
                    outlined
                  />
                </div>
              </div>

              <!-- بخش دکمه‌های عملیاتی (جابجایی و حذف) -->
              <div class="d-flex flex-column align-center mr-3 pr-3" style="border-right: 1px solid #eeeeee;">
                <v-btn icon small @click="moveMemoryUp(index)" :disabled="index === 0" class="mb-1">
                  <v-icon color="grey">mdi-chevron-up</v-icon>
                </v-btn>
                <v-btn icon small @click="moveMemoryDown(index)" :disabled="index === data.memories.length - 1">
                  <v-icon color="grey">mdi-chevron-down</v-icon>
                </v-btn>
                <v-btn icon color="error" class="mt-3" @click="removeMemory(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- دکمه افزودن فیلد -->
            <v-btn 
              style="width: 100%;"
              class="btn-get-code rounded-lg my-4"
              @click="addMemory"
            >
              <v-icon class="mx-2" right>mdi-heart-plus</v-icon>
              افزودن فیلد جدید
            </v-btn>

          </v-col>

        </v-row>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import SuggestText from "@/view/components/SuggestBox/suggestInput";
import IconPicker from "@/view/components/IconPicker";
import ExtraFileds from "../Product/extraFileds";
import HelpInfo from "../../pages/qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../pages/qrland/components/helpAcordion/HelpInfoWrapper.vue";
import customDatePicker from "../../content/custom-date-picker.vue";

const GIFT_ROUTES = [
  "qr.gift",
  "qr.name.editgift",
  "qr.name.id.editgift",
  "modelsList.memories.edit",
  "qr.create.memories"
];
const TEXT_ROUTES =[
  "qr.Qrtext",'qr.name.editText','qr.name.id.editText'];
export default {
  name: "baseInfo",
  components: {
    ExtraFileds,
    IconPicker,
    SuggestText,
    HelpInfo,
    HelpInfoWrapper,
    customDatePicker, 
  },
  props: {
    data: {
      default: () => ({}), 
    },
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "base-info",
      urlRules: [
        (value) =>
          this.isURL(value) ||
          "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
      ],
    };
  },
  mounted() {
    if (!this.data.memories) {
      this.$set(this.data, "memories", []);
    }
  },
  computed:{
        isGiftRoute() {
      return GIFT_ROUTES.includes(this.$route.name);
    },
    isTextRoute() {
      return TEXT_ROUTES.includes(this.$route.name);
    },

    isNotSicialRoute(){

    return !['qr.create.editSocialModel',
    'qr.create.SocialMediaModel',
    'qr.socialMedia','qr.name.id.editSocial',
    'qr.name.editSocial'].includes(this.$route.name);
    }

  },
  methods: {
    isURL(str) {
      let regex = /^[a-zA-Z0-9\-_~:?#[\]@!$&'()+,;=.]+$/;
      return regex.test(str);
    },
    addMemory() {
      if (!this.data.memories) {
        this.$set(this.data, "memories", []);
      }
      this.data.memories.push({ title: "", date: null,  icon: "mdi-cards-playing-heart-outline" });
    },
    removeMemory(index) {
      this.data.memories.splice(index, 1);
    },
    
    moveMemoryUp(index) {
      if (index > 0) {
        const item = this.data.memories.splice(index, 1)[0];
        this.data.memories.splice(index - 1, 0, item);
      }
    },
    
    moveMemoryDown(index) {
      if (index < this.data.memories.length - 1) {
        const item = this.data.memories.splice(index, 1)[0];
        this.data.memories.splice(index + 1, 0, item);
      }
    }
    },
};
</script>

<style scoped></style>
